import { Loading } from 'element-ui'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'

export function useLoading() {
  return Loading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.75)',
    customClass: elementUiStyles.loadingMask
  })
}
